import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getLookupReligion = createAsyncThunk("lookup/getLookupReligion", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/lookup/agama');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getCountry = createAsyncThunk("lookup/getCountry", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/lookup/wilayah/negara/all');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupProvince = createAsyncThunk("lookup/getLookupProvince", 
	async (countryId, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/lookup/wilayah/provinsi/${countryId}`);
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupCity = createAsyncThunk("lookup/getLookupCity", 
	async (stateId, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`/v1/lookup/wilayah/kota/${stateId}`);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupGender = createAsyncThunk("lookup/getLookupGender", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/jenis-kelamin');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupStatus = createAsyncThunk("lookup/getLookupStatus", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/status-aktif');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupJenjangPendidikan = createAsyncThunk("lookup/getLookupJenjangPendidikan", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/jenjang-pendidikan');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupPekerjaan = createAsyncThunk("lookup/getLookupPekerjaan", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/pekerjaan');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupPenghasilan = createAsyncThunk("lookup/getLookupPenghasilan", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/penghasilan');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupProdi = createAsyncThunk("lookup/getLookupProdi", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/program-studi/detail');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupDays = createAsyncThunk("lookup/getLookupDays", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/hari');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupStay = createAsyncThunk("lookup/getLookupStay", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/lookup/jenis-tinggal');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupKPS = createAsyncThunk("lookup/getLookupKPS", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('/v1/lookup/penerima-kps');
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getLookupMataKuliah = createAsyncThunk("lookup/getLookupMataKuliah", 
	async ({id_program_studi, nama_program_studi}, { rejectWithValue }) => {
		try {
			const token = localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/mata-kuliah/lookup?prodi=${id_program_studi}&nama=${nama_program_studi}`);
			return response.data;
		} catch (e) {
			rejectWithValue(e?.response?.data?.message || 'Error')
		}
	}
);

const initialState = {
	lookupReligion: [],
	lookupCountry:[],
	lookupProvince: [],
	lookupCity:[],
	lookupStatus:[],
	lookupGender: [],
	lookupJenjangPendidikan: [],
	lookupPekerjaan: [],
	lookupPenghasilan: [],
	lookupProdi: [],
	lookupDays: [],
	lookupMataKuliah: [],
	lookupStay:[],
	lookupKPS:[],
	status: {
		loading: false
	}
}

const lookupSlice = createSlice({
	name: "lookup",
	initialState,
	extraReducers: {
		[getLookupReligion.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupReligion.fulfilled]: (state, action) => {
			state.lookupReligion = action.payload;
			state.status.loading = false;
		},
		[getLookupReligion.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getCountry.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getCountry.fulfilled]: (state, action) => {
			state.lookupCountry = action.payload;
			state.status.loading = false;
		},
		[getCountry.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupProvince.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupProvince.fulfilled]: (state, action) => {
			state.lookupProvince = action.payload;
			state.status.loading = false;
		},
		[getLookupProvince.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupCity.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupCity.fulfilled]: (state, action) => {
			state.lookupCity = action.payload;
			state.status.loading = false;
		},
		[getLookupCity.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupGender.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupGender.fulfilled]: (state, action) => {
			state.lookupGender = action.payload;
			state.status.loading = false;
		},
		[getLookupGender.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupStatus.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupStatus.fulfilled]: (state, action) => {
			state.lookupStatus = action.payload;
			state.status.loading = false;
		},
		[getLookupStatus.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupJenjangPendidikan.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupJenjangPendidikan.fulfilled]: (state, action) => {
			state.lookupJenjangPendidikan = action.payload;
			state.status.loading = false;
		},
		[getLookupJenjangPendidikan.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupPekerjaan.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupPekerjaan.fulfilled]: (state, action) => {
			state.lookupPekerjaan = action.payload;
			state.status.loading = false;
		},
		[getLookupPekerjaan.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupPenghasilan.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupPenghasilan.fulfilled]: (state, action) => {
			state.lookupPenghasilan = action.payload;
			state.status.loading = false;
		},
		[getLookupPenghasilan.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupKPS.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupKPS.fulfilled]: (state, action) => {
			state.lookupKPS = action.payload;
			state.status.loading = false;
		},
		[getLookupKPS.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupProdi.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupProdi.fulfilled]: (state, action) => {
			state.lookupProdi = action.payload;
			state.status.loading = false;
		},
		[getLookupProdi.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupDays.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupDays.fulfilled]: (state, action) => {
			state.lookupDays = action.payload;
			state.status.loading = false;
		},
		[getLookupDays.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupMataKuliah.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupMataKuliah.fulfilled]: (state, action) => {
			state.lookupDays = action.payload;
			state.status.loading = false;
		},
		[getLookupMataKuliah.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getLookupStay.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getLookupStay.fulfilled]: (state, action) => {
			state.lookupStay = action.payload;
			state.status.loading = false;
		},
		[getLookupStay.rejected]: (state, action) => {
			state.status.loading = false;
		},
	}
})

export const selectLookup = (state) => state.lookup;

export default lookupSlice.reducer;